import { Node, mergeAttributes } from '@tiptap/core';

const WordMatrixContent = Node.create({
  name: 'wordMatrixContent',
  group: 'block',
  atom: true,
  draggable: false,
  selectable: true,

  addAttributes() {
    return {
      'data-base-word': {
        default: '',
        parseHTML: (element) => {
          const attr = element.getAttribute('data-base-word');
          if (attr) return attr;
          const baseEl =
            element.querySelector('.word-matrix-base') ||
            element.querySelector('.base-word');
          return baseEl?.textContent || '';
        },
      },
      'data-prefix-columns': {
        default: '',
        parseHTML: (element) => {
          const attr = element.getAttribute('data-prefix-columns');
          if (attr) return attr;
          // Legacy: single data-prefixes attr → treat as one column
          const legacy = element.getAttribute('data-prefixes');
          if (legacy) return legacy;
          // Fall back to child elements
          const cols = Array.from(
            element.querySelectorAll('.word-matrix-prefix-col'),
          );
          if (cols.length === 0) return '';
          return cols
            .map((col) =>
              Array.from(col.querySelectorAll('.prefix'))
                .map((el) => el.textContent || '')
                .filter(Boolean)
                .join(','),
            )
            .join('|');
        },
      },
      'data-suffix-columns': {
        default: '',
        parseHTML: (element) => {
          const attr = element.getAttribute('data-suffix-columns');
          if (attr) return attr;
          // Legacy: single data-suffixes attr → treat as one column
          const legacy = element.getAttribute('data-suffixes');
          if (legacy) return legacy;
          // Fall back to child elements
          const cols = Array.from(
            element.querySelectorAll('.word-matrix-suffix-col'),
          );
          if (cols.length === 0) return '';
          return cols
            .map((col) =>
              Array.from(col.querySelectorAll('.suffix'))
                .map((el) => el.textContent || '')
                .filter(Boolean)
                .join(','),
            )
            .join('|');
        },
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div.word-matrix-content' }];
  },

  renderHTML({ HTMLAttributes }) {
    const baseWord = HTMLAttributes['data-base-word'] || '';
    const prefixColumnsStr = HTMLAttributes['data-prefix-columns'] || '';
    const suffixColumnsStr = HTMLAttributes['data-suffix-columns'] || '';

    const prefixColumns: string[][] = prefixColumnsStr
      ? prefixColumnsStr
          .split('|')
          .map((col: string) => col.split(',').filter(Boolean))
      : [[]];
    const suffixColumns: string[][] = suffixColumnsStr
      ? suffixColumnsStr
          .split('|')
          .map((col: string) => col.split(',').filter(Boolean))
      : [[]];

    const prefixColElements: any[] = prefixColumns.map((col) => [
      'div',
      { class: 'word-matrix-prefix-col' },
      ...col.map((p) => ['span', { class: 'prefix' }, p]),
    ]);

    const suffixColElements: any[] = suffixColumns.map((col) => [
      'div',
      { class: 'word-matrix-suffix-col' },
      ...col.map((s) => ['span', { class: 'suffix' }, s]),
    ]);

    return [
      'div',
      mergeAttributes(
        { class: 'word-matrix-content' },
        {
          'data-base-word': HTMLAttributes['data-base-word'],
          'data-prefix-columns': HTMLAttributes['data-prefix-columns'],
          'data-suffix-columns': HTMLAttributes['data-suffix-columns'],
        },
      ),
      ...prefixColElements,
      ['div', { class: 'word-matrix-base' }, baseWord],
      ...suffixColElements,
    ];
  },
});

export default WordMatrixContent;
